import { computed } from "vue";
import { useSharedState } from "composables/useSharedState";
import { mergeClassProp } from "@/runtime/style-engine/define-variants";
import type { TabListProps } from "./tab.types";
import { tabListClasses } from "./tab.styles";

export interface UseTabListOptions {
  props: Readonly<TabListProps>;
}

export const useTabList = (options: UseTabListOptions) => {
  const { props } = options;
  useSharedState(props);

  const classes = computed(() => mergeClassProp(tabListClasses(), props.class));

  return { classes };
};
